import { SHORT_URL_EVENTS } from "@/modules/tracking/consts/Events";
import { ShortUrlFlow } from "@/modules/tracking/consts/ShortUrl";
import {
  endShortUrlFlowSession,
  getShortUrlFlowSession,
  timeInFlowSeconds,
} from "@/modules/tracking/utils/shortUrlFlowSession";
import { trackShortUrlEvent } from "@/modules/tracking/utils/trackShortUrlEvent";

export function abandonPreviousShortUrlFlowIfDifferent(
  newFlow: ShortUrlFlow,
  newAccessCode: string,
): void {
  const existing = getShortUrlFlowSession();
  if (!existing) return;
  if (existing.flow === newFlow && existing.accessCode === newAccessCode) {
    return;
  }

  trackShortUrlEvent(SHORT_URL_EVENTS.FLOW_ABANDONED, {
    flow: existing.flow,
    session_id: existing.sessionId,
    source: existing.source,
    last_screen: existing.lastScreen,
    time_in_flow_seconds: timeInFlowSeconds(existing.startedAt),
  });

  endShortUrlFlowSession();
}
